import { Container, Paper, Stack, Text, UnstyledButton } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { EMAIL_TEMPLATES } from "../components/Templates/emailTemplates";

const TemplatePreviews = () => {
  const navigate = useNavigate();

  return (
    <Container size={700}>
      <Stack gap="sm" mt="md">
        {EMAIL_TEMPLATES.map((template) => (
          <UnstyledButton
            key={template.name}
            onClick={() => navigate(`./${template.name}`)}
          >
            <Paper withBorder shadow="sm" p="md" radius="md">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <template.icon size={20} />
                <Text fw={500}>{template.label}</Text>
              </div>
            </Paper>
          </UnstyledButton>
        ))}
      </Stack>
    </Container>
  );
};

export default TemplatePreviews;
